export default __webpack_public_path__ + "static/hold-7f9df5517685ec633fc4800ee1c9c742.png";